import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import TrafficlightButtonGreen from "../../../../../../../components/Button/TrafficlightButtonGreen";
import { TextSignalCardio } from "./TextSignalCardio";


export default function Cardio_Signal() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

<IconButton onClick={handleOpen}>
    <TrafficlightButtonGreen  />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

    title= 'Cardio Panel Variants - Analysis'

    content={ <TextSignalCardio />}

/>

</>
)}